var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 9.75V8.75C17.75 4.979 17.75 3.093 16.579 1.922C15.408 0.751 13.52 0.75 9.75 0.75H8.75C4.98 0.75 3.093 0.75 1.922 1.922C0.751 3.094 0.75 4.979 0.75 8.75V12.75C0.75 16.521 0.75 18.407 1.922 19.578C3.094 20.749 4.979 20.75 8.75 20.75",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.75H13.25M5.25 10.75H13.25",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.5775V20.7505H12.424C12.833 20.7505 13.038 20.7505 13.222 20.6745C13.406 20.5985 13.551 20.4535 13.84 20.1645L18.664 15.3395C18.937 15.0665 19.074 14.9295 19.146 14.7835C19.285 14.5035 19.285 14.1735 19.146 13.8935C19.073 13.7465 18.936 13.6105 18.664 13.3375C18.39 13.0645 18.254 12.9275 18.107 12.8545C17.9687 12.7858 17.8164 12.75 17.662 12.75C17.5076 12.75 17.3553 12.7858 17.217 12.8545C17.07 12.9275 16.933 13.0645 16.661 13.3375L11.837 18.1615C11.547 18.4505 11.403 18.5955 11.327 18.7795C11.251 18.9635 11.25 19.1675 11.25 19.5775Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.9fc026e1b00166eded219ff00c6dbd6a.svg";
export { ForwardRef as ReactComponent };